import { CopiarRotaFormModel } from "../modelos/rota/copiarRotaFormModel";

export const COPIAR_ROTA_FORM_INITIAL_STATE: CopiarRotaFormModel = {
    idRota: "",
    novaDescricao: ""
  };
  